import React, { useCallback } from 'react';
import { connectSortBy } from 'react-instantsearch-core';
import styles from './sort-by.module.css';
import ChevronDown from '$icons/chevron-down.svg';

import { useTranslation } from '~/shared/utils/translation';
import { TranslationKey } from '~/lib/data-contract';
import { useGtm } from '~/shared/utils';
import { invalidateCache } from '~/shared/utils/algolia';
import { useFilterUIState } from '~/features/productsList/hooks';

interface SortType {
    key: string;
    value: string;
}

interface SortByProps {
    items: SortType[];
    currentRefinement: string;
    refine: (value?: string) => void;
}

const CustomSortBy = ({ items, currentRefinement, refine }: SortByProps) => {
    const { translate } = useTranslation();
    const { trackProductSorting } = useGtm();
    const { preSelectedIndexKey } = useFilterUIState();
    
    const actualValue = preSelectedIndexKey || currentRefinement;
    
    const setOrder = useCallback(
        (orderIndex: string) => {
            if (actualValue !== orderIndex) {
                const { pathname } = window.location;
                invalidateCache(pathname);
            }

            refine(orderIndex);
            const newSortOrder = items.find((item) => item.key === orderIndex);
            trackProductSorting(translate(newSortOrder?.value as TranslationKey));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [refine, items, trackProductSorting, translate, actualValue]
    );

    if (!items.length) return null;

    return (
        <div className={styles.selectWrapper}>
            <select
                onChange={(e) => setOrder(e.target.value)}
                className={styles.selectInput}
                name="sortBy"
                value={actualValue}
            >
                {items.map((item) => (
                    <option key={item.key} value={item.key}>
                        {translate(item.value as TranslationKey)}
                    </option>
                ))}
            </select>
            <ChevronDown className={styles.chevron} />
        </div>
    );
};

export const SortBy = React.memo(connectSortBy(CustomSortBy));
